import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

// Q1: Families overview (per-interface families/things/brands, by step)
const FAMILIES_OVERVIEW_QUERY_ID = "5694907842822144";
// Q2: Interface coverage (one row per interface + a TOTAL row)
const INTERFACE_COVERAGE_QUERY_ID = "5693995833360384";
// Q3: Brand step coverage (one row per brand across fetcher/unifier/advisor families)
const BRAND_STEP_COVERAGE_QUERY_ID = "5741157191516160";
// Q4: Needs Attention summary (empty families / families missing maps-configs)
const NEEDS_ATTENTION_QUERY_ID = "5745965138968576";

function getFamiliesOverview(
  oauthTokenHeader: string,
  website_shared_uid: any,
  backend_interface_id: any,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${FAMILIES_OVERVIEW_QUERY_ID}/?website_shared_uid=${website_shared_uid}&backend_interface_id=${backend_interface_id}`,
    oauthTokenHeader,
  );
}

function getInterfaceCoverage(oauthTokenHeader: string, website_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${INTERFACE_COVERAGE_QUERY_ID}/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

function getBrandStepCoverage(oauthTokenHeader: string, website_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${BRAND_STEP_COVERAGE_QUERY_ID}/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

function getNeedsAttentionSummary(oauthTokenHeader: string, website_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${NEEDS_ATTENTION_QUERY_ID}/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader,
  );
}

function createFamily(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/families/`,
    data,
    oauthTokenHeader,
  );
}

function updateFamily(oauthTokenHeader: string, familyId: any, data: any) {
  return fetchWrapper.put(
    `${apiUrl}/data_collection/families/${familyId}/`,
    data,
    oauthTokenHeader,
  );
}

function deleteFamily(oauthTokenHeader: string, urlId: any, data: any) {
  return fetchWrapper.delete(
    `${apiUrl}/data_collection/families/${urlId}/`,
    data,
    oauthTokenHeader,
  );
}

function checkFamiliesConnectability(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/families_connectability_check/`,
    data,
    oauthTokenHeader,
  );
}

export const familiesServices = {
  getFamiliesOverview,
  getInterfaceCoverage,
  getBrandStepCoverage,
  getNeedsAttentionSummary,
  createFamily,
  updateFamily,
  deleteFamily,
  checkFamiliesConnectability,
};
